import React, { useState } from 'react';
import { Facebook, Twitter, LinkedIn, Instagram } from '@mui/icons-material';
import axios from 'axios';


const MyFooter = () => {
  const [dataProp, setDataProp] = useState({

  })

  const url = process.env.REACT_APP_STRAPI_API
  const feUrl = process.env.REACT_APP_CMSFE_URL

  React.useEffect(() => {
    getData()
  }, []);
  async function getData() {

    const QuickLinks = await axios.get(`${url}/api/quick-links`)
    const ContactUs = await axios.get(`${url}/api/contacts`)
    const Support = await axios.get(`${url}/api/supports`)
    const Footer = await axios.get(`${url}/api/footer-logos?populate=*`)
    const FooterData = {
      footerLogos: Footer.data.data,
      support: Support.data.data,
      contact: ContactUs.data.data,
      quickLink: QuickLinks.data.data
    }
    setDataProp(FooterData)
  }



  return (
    <>
      {
        dataProp?.footerLogos ?
          <footer className="bg_dark_grey">
            <div className="container">
              <div className="row mb-4">
                <div className="col-lg-3 col-md-3 col-sm-12 mb-4 wow fadeInUp  animated" data-wow-delay="400ms"> <a href="#"> <img src={`${dataProp?.footerLogos[0]?.attributes?.footerLogo?.data?.attributes?.url}`} width="150" alt="" className="img-fluid" /></a>
                  <div className="py-3">
                    <p style={{ color: "rgb(206, 206, 206)" }}>{dataProp?.footerLogos[0]?.attributes?.footerContent}</p>
                  </div>
                  <a style={{ backgroundColor: "inherit" }} href="https://www.facebook.com" target="_blank" className="so-iocn"><Facebook style={{ color: "#D11D1D" }} /></a> <a style={{ backgroundColor: "inherit" }} href="https://www.twitter.com" target="_blank" className="so-iocn"><Twitter style={{ color: "#D11D1D" }} /></a> <a style={{ backgroundColor: "inherit" }} href="https://www.instagram.com" target="_blank" className="so-iocn"><Instagram style={{ color: "#D11D1D" }} /></a> <a style={{ backgroundColor: "inherit" }} href="https://www.linkedin.com" target="_blank" className="so-iocn"><LinkedIn style={{ color: "#D11D1D" }} /></a> </div>
                <div className="col-lg-3 col-md-3  col-sm-6 col-6 mb-4 wow  fadeIn  animated" data-wow-delay="100ms">
                  <div className="footerlinks">
                    <h4 style={{ color: "#CECECE" }}>{dataProp?.footerLogos[0]?.attributes?.section1}</h4>
                    <ul className="p-0">
                      {dataProp?.quickLink.map((item) => (
                        <li><a href={`${feUrl}${item?.attributes?.link}`} style={{ color: "#CECECE" }}>{item?.attributes?.Text}</a></li>
                      ))}
                      {/* <li><a href=''style={{color:"#CECECE"}}>investment</a></li>
            <li><a href=''style={{color:"#CECECE"}}>Faq</a></li>
            <li><a href=''style={{color:"#CECECE"}}>Blog</a></li>
            <li><a href=''style={{color:"#CECECE"}}>Contact Us</a></li> */}
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3  col-sm-6 col-6 mb-4 wow  fadeIn  animated" data-wow-delay="300ms">
                  <div className="footerlinks">
                    <h4 style={{ color: "#CECECE" }}>{dataProp?.footerLogos[0]?.attributes?.section2}</h4>
                    <ul className="p-0">
                      {dataProp?.support.map((item) => (
                        <li><a href={`${feUrl}${item?.attributes?.link}`} style={{ color: "#CECECE" }}>{item?.attributes?.Text}</a></li>
                      ))}
                      {/* <li><a href='' style={{color:"#CECECE"}}>Privacy</a></li> */}
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3  col-sm-6 col-6 mb-4 wow  fadeIn  animated" data-wow-delay="500ms">
                  <div className="footerlinks">
                    <h4>{dataProp?.footerLogos[0]?.attributes?.section3}</h4>
                    <p style={{ color: "#CECECE" }}>{dataProp?.contact[0]?.attributes?.Location}</p>
                    <p style={{ color: "#CECECE" }}>{dataProp?.contact[0]?.attributes?.Phone}</p>
                    <p><a href={`mailto:${dataProp?.contact[0]?.attributes?.Email}`} style={{ color: '#CECECE' }}>{dataProp?.contact[0]?.attributes?.Email}</a></p>
                  </div>
                </div>
              </div>
            </div>
            <div className="copyrights pt-4 pb-2 ">
              <div className="container">
                <div className="row" style={{ display: "flex", alignItems: "center" }}>
                  <div className="col-12 mb-2 text-center" style={{ color: "#CECECE", display: "flex", alignItems: "center", width: "50%" }}>Copyright © 2024 Funding Possibilities</div>
                  <div style={{ color: "#CECECE", display: "flex", alignItems: "center", width: "50%" }} className="col-12 mb-2 text-left">Version : v1.0.0</div>
                </div>
              </div>
            </div>
          </footer>
          :
          <></>
      }
    </>
    //   
  );
};

export default MyFooter;
